import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import { WarehouseContext } from '../../../Utility/UserContext';

import {
  getSuppliers,
  getWarehouses,
  getUnits,
  getProducts,
  createProductQty,
  getBrand,
  listtakenProductQty,
  getManufacturers,
  getWarehouseProduct,
} from "../../../Utility/Api";
import { validateDates, warehouse_id } from "../../../Utility/function";
import SupplierForm from "../Suppliers/form";

export const EditProductQty = ({
  showModal,
  setShowModal,
  selectedProductQty,
  fetchdata,
  AddorEdit
}) => {
  const [warehouse, setWarehouses] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [products, setProducts] = useState([]);
  const [Brand, setBrand] = useState([]);
  const [Manufacturers, setManufacturers] = useState([]);
  const [Takenvalue, setTakenvalue] = useState([]);
  const { showLoader, hideLoader, shopItem, UserItem, selectedWarehouse } = useContext(WarehouseContext);
  const [showSupplierModal, setshowSupplierModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
    setshowSupplierModal(false);
  };

  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    product_id: "",
    warehouse_id: warehouse_id,
    supplier_id: "",
    user_id: "",
    manufacturer_id: "",
    brand_id: "",
    in_or_out: "",
    qty: "",
    purchase_price: "",
    sales_price: "",
    batch_number: "",
    remark: "",
    bulk_price: "",
    status: "",
    remaining: "",
    manufacturing_date: "",
    warehouse_id: "",
    expiry_date: "",
    purchase_unit: "",
  });
  const [totalRemaining, setTotalRemaining] = useState(0);
  const [ProductUnit, setProductUnit] = useState(0);

  useEffect(() => {
    fetchWarehouse();
    fetchProducts();
    fetchSuppliers();
    fetchBrand();
    fetchManufacturers();
    fetchProductUnit();
  }, [selectedProductQty]);

  useEffect(() => {
    fetchWarehouseBasedProduct(selectedWarehouse?.id);
  }, [selectedWarehouse]);

  const fetchProductUnit = async () => {
    try {
      const response = await getUnits()
      console.log(response);
      if (response.data && response.data.data) {
        setProductUnit(response.data.data);
      }
    } catch (err) {
      console.error('Error, fetching Product Unit:', err);
    }
  }

  useEffect(() => {
    const total = Takenvalue.reduce(
      (acc, item) => acc + (Number(item.remaining) || 0),
      0
    );
    setTotalRemaining(total);
  }, [Takenvalue]);

  const fetchWarehouse = async () => {
    try {
      const response = await getWarehouses();
      if (response.data && response.data.data) {
        setWarehouses(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  const fetchProducts = async () => {
    try {
      const response = await getProducts();
      if (response.data && response.data.data) {
        setProducts(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching products data:", error);
    }
  };

  const fetchSuppliers = async () => {
    try {
      const response = await getSuppliers();
      if (response.data && response.data.data) {
        setSupplier(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching suppliers data:", error);
    }
  };

  const fetchBrand = async () => {
    try {
      const response = await getBrand();
      if (response.data && response.data.data) {
        setBrand(response.data.data);
        console.log(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  const fetchManufacturers = async () => {
    try {
      const response = await getManufacturers();
      if (response.data && response.data.data) {
        setManufacturers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Customers data:", error);
    }
  };

  const fetchWarehouseBasedProduct = async (id) => {
    try {
      const response = await getWarehouseProduct(id);
      if (response.data && response.data.data) {
        setProducts(response.data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async (e) => {
    showLoader()
    const validationErrors = {};

    for (const key in formData) {
      if (
        key === "product_id" ||
        key === "supplier_id" ||
        key === "qty" ||
        key === "purchase_price" ||
        key === "sales_price" ||
        key === "manufacturing_date" ||
        key === "purchase_unit"
      ) {
        if (!formData[key]) {
          validationErrors[key] = `${key.replace(/_/g, " ")} is required.`; // Generate error message dynamically
        }
      }
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      hideLoader()
      return;
    }

    if (formData.expiry_date) {
      var error = validateDates(formData.manufacturing_date, formData.expiry_date, 'Manufacturing', 'Expiry', true);
      if (error) {
        toast.error(error);
        hideLoader();
        return;
      }
    }

    const payload = {
      product_id: formData.product_id,
      warehouse_id: formData.warehouse_id,
      user_id: formData.user_id,
      in_or_out: formData.in_or_out,
      qty: formData.qty,
      total: formData.total,
      remaining: formData.remaining,
      status: formData.status,
      batch_number: formData.batch_number,
      supplier_id: formData.supplier_id,
      user_id: UserItem?.user_id || "0",
      manufacturer_id: formData.manufacturer_id,
      brand_id: "1",
      in_or_out: "0",
      shop_id: shopItem?.shop_id || "0",
      created_by: UserItem?.user_id || "0",
      purchase_price: formData.purchase_price,
      sales_price: formData.sales_price,
      bulk_price: formData.bulk_price,
      purchase_unit: formData.purchase_unit,
      remaining: formData.qty,
      manufacturing_date: formData.manufacturing_date,
      expiry_date: formData.expiry_date,
    };

    try {
      await createProductQty(payload);
      hideLoader()
      toast.success("Product Quantity Added successfully");
      setFormData({
        product_id: "",
        warehouse_id: warehouse_id,
        in_or_out: "",
        qty: "",
        total: "",
        remaining: "",
        batch_number: "",
        status: "",
        supplier_id: "",
        user_id: UserItem?.user_id || "0",
        manufacturer_id: "",
        purchase_price: "",
        sales_price: "",
        bulk_price: "",
        remaining: "",
        purchase_unit: "",
        manufacturing_date: "",
        formData: "",
      });
      setShowModal(false);
      fetchdata();
    } catch (error) {
      console.error("Error Product Quantity data:", error);
      hideLoader()
      toast.error("Error saving Product Quantity");
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (["qty", "purchase_price", "sales_price", "bulk_price"].includes(name)) {
      if (!/^\d*$/.test(value)) {
        return; // Exit if the input is not a valid number
      }
    }
    if (name === "qty" && formData.in_or_out == 1) {
      if (Number(value) > totalRemaining) {
        alert(
          `Entered quantity (${value}) exceeds the total remaining (${totalRemaining}).`
        );
        return;
      }
    }
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    if (name == "in_or_out" && value == "1") {
      try {
        const response = await listtakenProductQty(
          formData?.product_id,
          warehouse_id,
          formData?.manufacturer_id,
          formData?.supplier_id,
        );
        if (response?.data && response?.data?.data) {
          setTakenvalue(response?.data?.data);
        }
      } catch (error) {
        console.error("Error fetching users data:", error);
      }
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setErrors({
      product_id: "",
      warehouse_id: "",
      supplier_id: "",
      user_id: UserItem?.user_id || "0",
      manufacturer_id: "",
      in_or_out: "",
      qty: "",
      purchase_price: "",
      sales_price: "",
      bulk_price: "",
      status: "",
      remaining: "",
      purchase_unit: "",
      manufacturing_date: "",
    });
    setFormData({
      product_id: "",
      warehouse_id: "",
      supplier_id: "",
      user_id: UserItem?.user_id || "0",
      manufacturer_id: "",
      in_or_out: "",
      qty: "",
      purchase_price: "",
      sales_price: "",
      bulk_price: "",
      status: "",
      remaining: "",
      purchase_unit: "",
      manufacturing_date: "",
      formData: "",
    });
  };

  const FormInput = (label, name, value, onChange, type = "text", required = false) => (
    <div className="form-group mb-3 d-flex align-items-center">
      <label className="col-4 text-normal">{label}</label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className="form-control text-normal"
        required={required}
      />
    </div>
  );

  return (
    <>
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title">
                  {selectedProductQty
                    ? "Edit Product Quantity"
                    : "Add Product Quantity"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => handleCancel()}
                ></button>
              </div>
              <div className="modal-body" style={{ fontFamily: "poppins" }}>
                <div className="form-group mb-2 d-flex align-items-center">
                  <label className="col-4 text-normal">Supplier</label>
                  <select
                    name="supplier_id"
                    value={formData.supplier_id}
                    onChange={handleChange}
                    className="form-control text-normal"
                    required
                  >
                    <option value="">Select Supplier</option>
                    {supplier.filter(supplier => supplier.status != 2).map((suply) => (
                      <option key={suply.supplier_id} value={suply.supplier_id}>
                        {suply.full_name}
                      </option>
                    ))}
                  </select>
                  <button
                    className="btn btn-primary btn-sm d-flex align-items-center justify-content-center ms-2"
                    style={{ width: "30px", height: "30px" }}
                    onClick={() => setshowSupplierModal(true)} // Open modal
                    type="button"
                  >
                    <span style={{ fontSize: "18px" }}>+</span>
                  </button>
                </div>
                <div className="text-end">
                  {errors.supplier_id && (
                    <small className="text-danger">{errors.supplier_id}</small>
                  )}
                </div>
                <div className="form-group mb-2 d-flex align-items-center">
                  <label className="col-4 text-normal">Manufacturer</label>
                  <div className="col-8">
                    <select
                      name="manufacturer_id"
                      value={formData.manufacturer_id}
                      onChange={handleChange}
                      className="form-control text-normal"
                      required
                    >
                      <option value="">Select Manufacturer</option>
                      {Manufacturers.map((Manu) => (
                        <option
                          key={Manu.manufacturer_id}
                          value={Manu.manufacturer_id}
                        >
                          {Manu.name}
                        </option>
                      ))}
                    </select>
                    {errors.manufacturer_id && (
                      <small className="text-danger">
                        {errors.manufacturer_id}
                      </small>
                    )}
                  </div>
                </div>
                <div className="form-group mb-2 d-flex align-items-center d-none">
                  <label className="col-4 text-normal">Warehouse</label>
                  <div className="col-8">
                    <select
                      name="warehouse_id"
                      value={formData.warehouse_id}
                      onChange={handleChange}
                      className="form-control text-normal"
                      required>
                      <option value="">Select Warehouse</option>
                      {warehouse.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-group mb-2 d-flex align-items-center">
                  <label className="col-4 text-normal">Unit</label>
                  <div className="col-8">
                    <select
                      name="purchase_unit"
                      value={formData.purchase_unit}
                      onChange={handleChange}
                      className="form-control text-normal"
                      required>
                      <option value="">Select Unit</option>
                      {Array.isArray(ProductUnit) && ProductUnit.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="text-end">
                  {errors.purchase_unit && (
                    <small className="text-danger">{errors.purchase_unit}</small>
                  )}
                </div>
                <div className="form-group mb-2 d-flex align-items-center">
                  <label className="col-4 text-normal">Product</label>
                  <select
                    name="product_id"
                    value={formData.product_id}
                    onChange={handleChange}
                    className="form-control text-normal"
                    required>
                    <option value="">Select Product</option>
                    {products.filter(item => item.status != 2).map((pro) => (
                      <option key={pro.id} value={pro.product_id}>
                        {pro.product_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="text-end">
                  {errors.product_id && (
                    <small className="text-danger ">{errors.product_id}</small>
                  )}
                </div>
                <div className="form-group mb-3 d-flex align-items-center">
                  <label className="col-4 text-normal">
                    Quantity{" "}
                    {formData.in_or_out == 1 && (
                      <span className="text-danger">
                        Avilable qty {totalRemaining}
                      </span>
                    )}{" "}
                  </label>
                  <input
                    type="text"
                    name="qty"
                    value={formData.qty}
                    onChange={handleChange}
                    className="form-control text-normal"
                    required
                  />
                </div>
                <div className="text-end">
                  {errors.qty && (
                    <small className="text-danger">{errors.qty}</small>
                  )}
                </div>
                <>
                  {FormInput("Purchase Price", "purchase_price", formData.purchase_price, handleChange, "text", true)}
                  <div className="text-end">
                    {errors.purchase_price && (
                      <small className="text-danger">{errors.purchase_price}</small>
                    )}
                  </div>
                  {FormInput("Sales Price", "sales_price", formData.sales_price, handleChange, "text", true)}
                  <div className="text-end">
                    {errors.sales_price && (
                      <small className="text-danger">{errors.sales_price}</small>
                    )}
                  </div>
                  {FormInput("Manufacturer Date", "manufacturing_date", formData.manufacturing_date, handleChange, "date", true)}
                  <div className="text-end">
                    {errors.manufacturing_date && (
                      <small className="text-danger">{errors.manufacturing_date}</small>
                    )}
                  </div>
                  {FormInput("Expiry Date", "expiry_date", formData.expiry_date, handleChange, "date", false)}
                </>
                <div className="mt-5">
                  <button
                    className="btn btn-success float-end rounded-1 text-normal"
                    style={{ fontFamily: "poppins" }}
                    onClick={() => handleSubmit()}
                  >
                    Add Product Quantity
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ml-2 float-end me-1 rounded-1 text-normal"
                    style={{ fontFamily: "poppins" }}
                    onClick={() => handleCancel()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
              {showSupplierModal && (
                <SupplierForm
                  // selectedSupplier={selectedSupplier}
                  onClose={() => closeModal()}
                  fetchSuppliers={fetchSuppliers}
                />
              )}

            </div>
          </div>
        </div>
      )}
    </>
  );
};
